import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "308",
  "slug": "spot-ethiopia-from-satellite-imagery",
  "title": "How to Recognise Ethiopia in Satellite Images",
  "excerpt": "The Ethiopian Highlands form elevated terrain beside much lower, drier land in the northeast.",
  "date": "2026-03-28",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/ethiopia.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Ethiopian Highlands form elevated terrain beside much lower, drier land in the northeast. The Rift cuts through the region and includes a chain of lakes farther south. Closely spaced valleys and ridges in the highlands contrast with the broad lowlands to the east."
    },
    {
      "type": "heading",
      "text": "Highlands beside the Rift"
    },
    {
      "type": "paragraph",
      "text": "Compare the highlands around Lake Tana with the Afar lowlands. Look at changes in relief as well as colour."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Eritrea and Kenya share parts of this wider highland and rift setting. A dry surface or a single volcanic cone will not separate them. Examine how the high ground and basins fit together in a wider view."
    }
  ],
  "imageAlt": "Ethiopia regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
